import * as React from 'react'
import { Filter, FilterProps } from 'react-admin'
import { ProductsListFiltersArray } from './Filters'

const ProductsFilter: React.FC<Omit<FilterProps, 'children'>> = (props) => {
  return (
    <Filter {...props}>
      {ProductsListFiltersArray.map((item) => item.FilterInput)}
    </Filter>
  )
}

export default ProductsFilter
